"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var IAdapter = require("../../interfaces/IAdapter");
var _require = require("../../constants/loggingLevels"),
  logLevels = _require.logLevels,
  defaultLogLevel = _require.defaultLogLevel,
  getLogLevelValue = _require.getLogLevelValue,
  ADD_ATTRIBUTE = _require.ADD_ATTRIBUTE,
  OFF = _require.OFF,
  REMOVE_ATTRIBUTE = _require.REMOVE_ATTRIBUTE;
var shouldUseBaseLogLevels = function shouldUseBaseLogLevels(level) {
  return !level || typeof level !== "string" || !getLogLevelValue(level);
};
var BaseAdapter = /*#__PURE__*/function (_IAdapter) {
  function BaseAdapter(config) {
    var _this;
    (0, _classCallCheck2["default"])(this, BaseAdapter);
    _this = _callSuper(this, BaseAdapter);
    (0, _defineProperty2["default"])(_this, "config", null);
    (0, _defineProperty2["default"])(_this, "key", null);
    (0, _defineProperty2["default"])(_this, "attributes", {});
    (0, _defineProperty2["default"])(_this, "processors", []);
    (0, _defineProperty2["default"])(_this, "handlers", {});
    (0, _defineProperty2["default"])(_this, "onEvent", null);
    (0, _defineProperty2["default"])(_this, "initialized", false);
    (0, _defineProperty2["default"])(_this, "broadcastFn", null);
    _this.config = config;
    return _this;
  }
  (0, _inherits2["default"])(BaseAdapter, _IAdapter);
  return (0, _createClass2["default"])(BaseAdapter, [{
    key: "runProcessingQueue",
    value: function runProcessingQueue(logLevel, payloads) {
      return this.processors.reduce(function (result, processor) {
        return processor.processPayload(logLevel, result);
      }, payloads);
    }
  }, {
    key: "wrapEvent",
    value: function wrapEvent(level) {
      var _this2 = this;
      return function () {
        for (var _len = arguments.length, payload = new Array(_len), _key = 0; _key < _len; _key++) {
          payload[_key] = arguments[_key];
        }
        var finalPayloads = _this2.runProcessingQueue(level, payload);
        _this2.processMessage.apply(_this2, [level].concat((0, _toConsumableArray2["default"])(finalPayloads)));
      };
    }
  }, {
    key: "listenToLevel",
    value: function listenToLevel(level) {
      var listener = this.onEvent(level, this.wrapEvent(level), {
        objectify: true
      });
      this.handlers[level] = listener;
    }
  }, {
    key: "listenToCurrentLevels",
    value: function listenToCurrentLevels() {
      var _iterator = _createForOfIteratorHelper(this.levels),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var level = _step.value;
          if (!this.handlers[level]) {
            this.listenToLevel(level);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "listen",
    value: function listen(onLoggerEvent) {
      this.onEvent = onLoggerEvent;
      onLoggerEvent(ADD_ATTRIBUTE, this.addAttribute.bind(this));
      onLoggerEvent(REMOVE_ATTRIBUTE, this.removeAttribute.bind(this));
      this.listenToCurrentLevels();
    }
  }, {
    key: "buildAdapterLogLevels",
    value: function buildAdapterLogLevels(level) {
      if (level === OFF) {
        return [];
      }
      if (shouldUseBaseLogLevels(level)) {
        return logLevels;
      } else {
        return logLevels.filter(function (lv) {
          return getLogLevelValue(lv) >= getLogLevelValue(level);
        });
      }
    }
  }, {
    key: "addAttribute",
    value: function addAttribute(key, value) {
      this.attributes[key] = value;
    }
  }, {
    key: "removeAttribute",
    value: function removeAttribute(key) {
      delete this.attributes[key];
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(level) {
      var _this$handlers$level;
      (_this$handlers$level = this.handlers[level]) === null || _this$handlers$level === void 0 || _this$handlers$level.off();
      delete this.handlers[level];
    }
  }, {
    key: "decoratePayloadWithPrefix",
    value: function decoratePayloadWithPrefix() {
      return Object.entries(this.attributes).length ? "[".concat(Object.entries(this.attributes).map(function (_ref) {
        var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
          key = _ref2[0],
          val = _ref2[1];
        return "".concat(key, "=").concat(val);
      }).join("&"), "]") : "";
    }
  }, {
    key: "updateLogLevel",
    value: function updateLogLevel(newLevel) {
      var requiredLevels = this.buildAdapterLogLevels(newLevel);
      this.levels = requiredLevels;
      for (var _i = 0, _Object$keys = Object.keys(this.handlers); _i < _Object$keys.length; _i++) {
        var level = _Object$keys[_i];
        if (requiredLevels.indexOf(level) === -1) {
          this.unsubscribe(level);
        }
      }
      this.listenToCurrentLevels();
    }
  }, {
    key: "initialize",
    value: function initialize(broadcastFn) {
      var _this$config,
        _this$config$get,
        _this$config2,
        _this$config2$on,
        _this3 = this,
        _this$config3,
        _this$config3$on;
      if (this.initialized) {
        return;
      }
      this.initialized = true;
      this.broadcastFn = broadcastFn;
      var level = ((_this$config = this.config) === null || _this$config === void 0 || (_this$config$get = _this$config.get) === null || _this$config$get === void 0 ? void 0 : _this$config$get.call(_this$config, "logger.".concat(this.key))) || defaultLogLevel;
      this.levels = this.buildAdapterLogLevels(level);
      (_this$config2 = this.config) === null || _this$config2 === void 0 || (_this$config2$on = _this$config2.on) === null || _this$config2$on === void 0 || _this$config2$on.call(_this$config2, "change.logger.".concat(this.key), function (_ref3) {
        var value = _ref3.value;
        _this3.updateLogLevel(value);
      });
      (_this$config3 = this.config) === null || _this$config3 === void 0 || (_this$config3$on = _this$config3.on) === null || _this$config3$on === void 0 || _this$config3$on.call(_this$config3, "merge", function () {
        var level = _this3.config.get("logger.".concat(_this3.key));
        _this3.updateLogLevel(level);
      });
    }
  }]);
}(IAdapter);
module.exports = BaseAdapter;